import styled from 'styled-components';

export const PaymentDescriptionStyles = styled.div`
  margin: 0 0 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const PaymentDescriptionRowStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0;
`;
